var map = {
	"./bccsa/logoExtended.png": 1605,
	"./cressey/logoExtended.png": 1606,
	"./csam/logoExtended.png": 1607,
	"./goldenacorn/logoExtended.png": 1608,
	"./ibew/logoExtended.png": 1609,
	"./orangepiggy/logoExtended.png": 1610,
	"./wgplangrid/logoExtended.png": 1611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1604;